import React, { Fragment, useEffect, useState } from 'react'
import NotificationItem from './NotificationItem'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { gear } from '@fortawesome/free-solid-svg-icons'
import "./index.css";
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const Notification = ({notificationData, counter})=>{

   var [notifications,setNotifications]= useState([])

   const removeNotification = (id)=>{
      let newNotifications = notifications.filter(item => item.id !== id)
      setNotifications(newNotifications)
   }

   axios.defaults.headers.common["Authorization"] =
   "Bearer " + localStorage.getItem("tok");

   useEffect(() => {
    
       if(notificationData)
        {
          let _new = [];
          _new = notificationData.sort(function(a, b) {
            let date_1 = (new Date(a.createdDate)).getTime()
            let date_2 = (new Date(b.createdDate)).getTime()
      
            return date_2 - date_1;
          });
          setNotifications(_new);
         counter(0)
         axios.put('notification/read-alls').then(result=>{
         })
        }
   },[notificationData])
   function sortEvent(e) {

      let { target: { value } } = e
      let _new = [];
  
      if (value === "0") {
  
        _new = notifications.sort(function(a, b) {
          let date_1 = (new Date(a.createdDate)).getTime()
          let date_2 = (new Date(b.createdDate)).getTime()
    
          return date_2 - date_1;
        });
      } else {
  
        _new = notifications.sort(function(a, b) {
          let date_1 = (new Date(a.createdDate)).getTime()
          let date_2 = (new Date(b.createdDate)).getTime()
    
          return date_1 - date_2;
        });
  
      }
      
      
  
      setNotifications([..._new]);
    }
   return (
       <Fragment>
            <div className="notificacion-container container">
              <div className='header-notification'>
                 <h4>Notificaciones</h4>
                 <FontAwesomeIcon icon="fa-solid fa-gear" />
                 <div className="">
            <div className="col-12 d-flex justify-content-end select-class">
              <label for="staticEmail" className="col-sm-4 col-form-label">
              Filtrar: 
              </label>

              <select
                className="col-sm-2 form-select form-select-sm"
                aria-label="Default select example"
                onChange={sortEvent}
                defaultValue="0"
              >
                <option value="0" >Más reciente</option>
                <option value="1">Más antiguo</option>
              </select>
            </div>
          </div>
              </div>
           {
               notifications && notifications.map(item => {
                  return <NotificationItem notification={item} deleteCallback={()=>{
                    removeNotification(item.id)
                  }}></NotificationItem>
               })
           }
           
            </div>
           
       </Fragment>
   )

}

export default Notification;